<template>
  <div class="hello">
    <div class="page_top" v-if="showData">
      <div class="top_kk">
        <span class="logo"><img src="https://www.360ping.com/images/pc_logo.png" @click="goindex"
            style=" cursor:pointer;"></span>
        <span class="top_dlxx">

          <em><img src="https://www.360ping.com/images/wx/pc_tx.png">{{ userInfo.studentDetail
            .name
          }}，您好！</em>
          <em class="qh" @click="chooseUser" v-if="userInfo.studentCount > 1"><i
              class="icon iconfont icon-qiehuanyonghu"></i>切换学生</em>
          <em class="tc" @click="loginOutOpt">退出系统</em>

        </span>
      </div>
    </div>

    <div class="page_dhxx" v-if="showData">
      <div class="dh">
        <!-- <span class="active" onclick="javascript:window.location.href='index.html'">生成记录</span> -->
        <router-link :to="{ path: '/record' }" active-class="active" tag="span">生成记录</router-link>
        <router-link :to="{ path: '/homeworkErrorBook' }" active-class="active" tag="span" v-if="haveWork">作业错题本</router-link>
        <router-link :to="{ path: '/examinationReport' }" active-class="active" tag="span">考试报告/错题本</router-link>
        <!-- <span onclick="javascript:window.location.href='zuoye_ctb.html'">作业错题本</span>
        <span onclick="javascript:window.location.href='kaoshi_ctb.html'">考试报告/错题本</span> -->
        <em class="r_sm" @click="showEwmCode">查看相关分析报告，请点击<i class="icon iconfont icon-0-46"></i></em>
      </div>
    </div>
    <router-view v-if="showData" />
    <div class="page_bottom" v-if="showData">
      <div class="bottom_kk">
        <span class="jbxx">
          版权所有Copyright @ 2023 www.360ping.com All rights reserved<br>
          <a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备10000723号-2</a>
        </span>
        <div class="bm_ma">
          <span><img src="https://www.360ping.com/images/wx_gzh.png"><em>关注公众号</em></span>
          <span><img src="https://www.360ping.com/images/wx_xcx.png"><em>扫码使用系统</em></span>
        </div>
      </div>
    </div>

    <el-dialog title="扫码查看" :visible.sync="codeVisible" class="layui-layer-dialog" width="280px">
      <div id="" class="layui-layer-content" v-loading="loading">
        <div class="tc_ma"><img :src="'data:image/png;base64,' + codeImg" v-if="codeImg"><span><i
              class="icon iconfont icon-weixin2"></i>微信扫码查看</span>
        </div>
      </div>
      <div class="layui-layer-btn layui-layer-btn-"><a class="layui-layer-btn0" @click="codeVisible = false">确认</a>
      </div>
    </el-dialog>

    <el-dialog title="切换学生" :visible.sync="dialogVisible" class="layui-layer-dialog" width="280px">
      <div id="" class="layui-layer-content" v-if="dialogVisible">
        <div class="tc_qh_xx">
          <div @click="confirmChoose(item)" :class="item.nowStudent == 1 ? 'xs active' : 'xs '"
            v-for="(item, index) in userLi" :key="item.id"><span>{{ item.name }}</span></div>
          <!-- <div class="xs"><span>李四</span></div> -->
          <div class="ts">切换后，手机端也会自动切换默认学生信息</div>
        </div>
      </div>
      <div class="layui-layer-btn layui-layer-btn-"><a class="layui-layer-btn0">确定</a></div>
    </el-dialog>

    <el-dialog title="操作提示" :visible.sync="outVisible" class="layui-layer-dialog" width="280px">
      <div id="" class="layui-layer-content">确定退出系统吗？</div>
      <div class="layui-layer-btn layui-layer-btn-"><a class="layui-layer-btn0" @click="confirmOut()">确认</a><a
          class="layui-layer-btn1" @click="outVisible = false">取消</a></div>
    </el-dialog>
  </div>
</template>
  
<script>
import {
  getUserInfo, loginOut, getUserStudentLi, changeNowStudent, queryQrCode, getUserFggPwd, loginAjax, querySchool
} from "../api/request";

export default {
  name: 'index',
  data() {
    return {
      outVisible: false,
      dialogVisible: false,
      userInfo: { studentDetail: { name: '' } },
      showData: false,
      userLi: [],
      codeVisible: false,
      codeImg: '',
      loading: false,
      haveWork:0,
    }
  },
  mounted() {
    this.getInfo();

  },
  methods: {
    showEwmCode() {
      this.codeVisible = true;
      this.loading = true;
      queryQrCode({ url: 'https://www.360ping.com/mp?p=0' }).then((res) => {
        if (res.data.code == 200) {

          this.codeImg = res.data.data;
          this.loading = false;
        }
      })

    },
    goindex() {
      this.$router.push('/')
    },
    getInfo() {
      getUserInfo().then((res) => {
        if (res.data.code == 200) {
          this.userInfo = res.data.data;
          if (this.userInfo.studentDetail) {
            sessionStorage.setItem('stuid', this.userInfo.studentDetail.id)
            sessionStorage.setItem('ifVip', this.userInfo.studentDetail.stuIfVip)
            if(this.userInfo.studentDetail.fgg_stu_user_id){
              sessionStorage.setItem('fgg_stu_user_id', this.userInfo.studentDetail.fgg_stu_user_id)
            }
          }
          querySchool().then((res_s) => {
            if (res_s.data.code == 200) {
              let info = JSON.parse(res_s.data.data.info);
              if (info.homework) {
                sessionStorage.setItem('haveWork', 1);
                this.haveWork = 1;
              } else {
                sessionStorage.setItem('haveWork', 0);
                this.haveWork = 0;
              }
            } else {
              sessionStorage.setItem('haveWork', 0);
              this.haveWork = 0;
            }
            this.showData = true;
          })
          
        }
      })
    },
    confirmChoose(data) {
      changeNowStudent({ studentId: data.id }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: '切换成功',
            type: 'success'
          });
          getUserFggPwd().then((res_fgg) => {
            if (res_fgg.data.code == 200) {
              if (res_fgg.data.data) {
                // 分高高模拟登录......
                loginAjax({ userName: res_fgg.data.data.tel, passWord: res_fgg.data.data.pwd, source: 15 }).then((res_s) => {
                  setTimeout(() => {
                    this.$router.go(0)
                  }, 200)
                  this.dialogVisible = false;

                })
              }
            } else {
              setTimeout(() => {
                this.$router.go(0)
              }, 200)
              this.dialogVisible = false;
            }
          })

          // this.getInfo();
        } else {
          this.$message({
            showClose: true,
            message: res.data.msg,
            type: 'error'
          });
        }
      })
    },
    confirmOut() {
      loginOut().then(() => {
        this.$router.push('/login')
      })
    },
    loginOutOpt() {
      this.outVisible = true;
    },
    chooseUser() {
      getUserStudentLi().then((res) => {
        console.log(res.data.data);
        if (res.data.code == 200) {
          this.userLi = res.data.data;
          this.dialogVisible = true;
        } else {
          this.$message({
            showClose: true,
            message: res.data.msg,
            type: 'error'
          });
        }
      })

    }
  }
}
</script>
  
<style lang="less" scoped>
@import url("../assets/layer.css");
@import url("../assets/public_style.css");
@import url("../assets/pc_style.css");

/deep/.el-dialog__body {
  padding: 0;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
</style>
  


// WEBPACK FOOTER //
// src/components/index.vue